import '../App.less';
import RunRegister from './RunRegister';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { Spin } from 'antd';
import loader  from '../images/quantum-loaderve1.gif'
import { FC, useEffect, useState } from 'react';

import Emitter from './util/eventEmitter';

const client = new ApolloClient({
    uri: process.env.REACT_APP_APOLLO_CLIENT,
    cache: new InMemoryCache({
        addTypename: false
    }),

});

const Run:FC =() =>{


   /* Eventos que se ejecutan desde cualquier microfront
     estos validan si se debe mostrar el GIF de carga o no
  */
     const [showSpin, setShowSpin] = useState(false)

      Emitter.on("SHOW_SPIN", () => { setShowSpin(true)  })
      Emitter.on("HIDE_SPIN", () => { setShowSpin(false)  })
      
      useEffect(() => {
        setShowSpin(showSpin)
      },[showSpin])

    return (
        <>
            {/* se ejecuta el registro de la aplicacion , una vez autenticado */}
            <ApolloProvider client={client}>
            <Spin
            spinning={showSpin}
            indicator={<><img alt="" width={85.4} height={62.31} src={loader}></img></>}
            size={"small"}
            >
                {
        
                     <RunRegister></RunRegister>

                }
            </Spin>
            </ApolloProvider>

        </>
    )
}
export default Run;